var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props),
    React.createElement(
      "g",
      { fill: "#018489", fillRule: "evenodd" },
      React.createElement("rect", { width: "20", height: "20", x: "2", y: "1", opacity: ".12", rx: "10" }),
      React.createElement("path", { d: "M11.5 14c.275 0 .5.112.5.25l.002.5c0 .138-.223.25-.5.25-.276 0-.5-.112-.5-.25l-.002-.5c0-.138.223-.25.5-.25zm.2-7c1.873 0 3.3.758 3.3 2.5 0 .95-.602 1.559-1.678 2.093-.091.045-.974.445-1.111.532l-.012.006v.451c0 .276-.223.5-.5.5-.276 0-.5-.224-.5-.5V12c0-.32.182-.533.477-.72.206-.13 1.17-.567 1.201-.583.77-.381 1.123-.74 1.123-1.197 0-1.019-.906-1.5-2.3-1.5-.673 0-1.242.361-1.474.914-.107.255-.4.374-.654.267-.255-.107-.375-.4-.268-.654C9.695 7.595 10.633 7 11.7 7z" })
    )
  );
});